import { observer } from "mobx-react-lite"

import type { WithdrawStore } from "@/domains/lock-page/withdraw-store"
import { WithdrawCheckingExpired } from "@/domains/lock-page/components/card/withdraw-card/composables/withdraw-panels/1.withdraw-checking-expired"
import { WithdrawNotExpired } from "@/domains/lock-page/components/card/withdraw-card/composables/withdraw-panels/2.withdraw-not-expired"
import { WithdrawExpired } from "@/domains/lock-page/components/card/withdraw-card/composables/withdraw-panels/3.withdraw-expired"
import { WithdrawCheckingResetRequired } from "@/domains/lock-page/components/card/withdraw-card/composables/withdraw-panels/4.withdraw-checking-reset-required"
import { WithdrawResetRequired } from "@/domains/lock-page/components/card/withdraw-card/composables/withdraw-panels/5.withdraw-reset-required"
import { WithdrawResetting } from "@/domains/lock-page/components/card/withdraw-card/composables/withdraw-panels/6.withdraw-resetting"
import { WithdrawResetFailed } from "@/domains/lock-page/components/card/withdraw-card/composables/withdraw-panels/7.withdraw-reset-failed"
import { WithdrawWithdrawAllowed } from "@/domains/lock-page/components/card/withdraw-card/composables/withdraw-panels/8.withdraw-withdraw-allowed"
import { WithdrawWithdrawing } from "@/domains/lock-page/components/card/withdraw-card/composables/withdraw-panels/9.withdraw-withdrawing"
import { WithdrawWithdrawFailed } from "@/domains/lock-page/components/card/withdraw-card/composables/withdraw-panels/10.withdraw-withdraw-failed"
import { WithdrawWithdrawn } from "@/domains/lock-page/components/card/withdraw-card/composables/withdraw-panels/11.withdraw-withdrawn"

interface WithdrawStateComponentMapProps {
  store: WithdrawStore
  governanceTokenSymbol?: string
}

export const WithdrawStateComponentMap = observer(
  ({ store, governanceTokenSymbol }: WithdrawStateComponentMapProps) => {
    switch (store.state) {
      case "idle":
        return <WithdrawCheckingExpired store={store} />

      case "checking-expired":
        return <WithdrawCheckingExpired store={store} />

      case "not-expired":
        return <WithdrawNotExpired store={store} />

      case "expired":
        return <WithdrawExpired store={store} />

      case "checking-reset-required":
        return <WithdrawCheckingResetRequired store={store} />

      case "reset-required":
        return <WithdrawResetRequired store={store} />

      case "resetting":
        return <WithdrawResetting store={store} />

      case "reset-failed":
        return <WithdrawResetFailed store={store} />

      case "withdraw-allowed":
        return <WithdrawWithdrawAllowed store={store} governanceTokenSymbol={governanceTokenSymbol} />

      case "withdrawing":
        return <WithdrawWithdrawing store={store} />

      case "withdraw-failed":
        return <WithdrawWithdrawFailed store={store} />

      case "withdrawn":
        return <WithdrawWithdrawn store={store} governanceTokenSymbol={governanceTokenSymbol} />

      default:
        return <div>Unknown state</div>
    }
  },
)
